import { createSlice } from '@reduxjs/toolkit'
import { ClaimResponse } from '~/Services/Claim'

export interface ClaimReducerStore {
  listClaimData: ClaimResponse | null
}

const initialState: ClaimReducerStore = {
  listClaimData: null,
}

export const ClaimSlice = createSlice({
  name: 'claim',
  initialState,
  reducers: {
    getClaimsRequest: () => {},
    setClaimsSuccess: (state, action) => {
      state.listClaimData = action.payload
    },
  },
})

export const ClaimActions = ClaimSlice.actions
export const ClaimReducer = ClaimSlice.reducer
